import { ref } from 'vue';
import { defineStore } from 'pinia';
import { SupportedLanguageEnum } from '@app/utils/enums';
import { setLocale } from '@app/api';

export const useLocaleStore = defineStore('localeStore', () => {
  const currentLang = ref<SupportedLanguageEnum>(SupportedLanguageEnum.Default);
  const changeLang = (lang: SupportedLanguageEnum) => {
    return setLocale(lang)
      .then((res) => {
        if (res.status === 200) {
          currentLang.value = lang;
          localStorage.setItem('lang', lang);
        }
      })
      .catch((err) => console.error('Something went wrong', err));
  };

  const readLangFromStorage = () => {
    return localStorage.getItem('lang');
  };
  return {
    currentLang,
    changeLang,
    readLangFromStorage
  };
});
